<div *ngIf="!loggedIn" class="section">
    <div *ngIf="utilService.getWidth() > 1024" class="bg-triangle"></div>
    <div *ngIf="utilService.getWidth() > 1024" class="_wf-lp-logo-container">
        <div class="_wf-lp-logo" *ngIf="!headerInfo.default_login_logo_needed">
            <img class="image-35" src="/assets/images/Sample logo.png">
        </div>
        <div class="_wf-lp-logo" *ngIf="headerInfo.default_login_logo_needed">
            <img class="image-35" [src]="headerInfo.login_logo">
        </div>
        <!--super app-->
        <!-- <div *ngIf="superApps && superApps.length>1" id="super-app" class="dropdown header-dropdown dd-hover" data-toggle="dropdown"
            [triggered]="config.showSuperAppMenu" aria-haspopup="true" aria-expanded="false"
            (click)="config.showSuperAppMenu = !config.showSuperAppMenu;">
            <div class="super-app-icon-container">
                <i class="fa fa-th" aria-hidden="true"></i>
            </div>
            <div id="super-app-m-body" class="_menu-dropdown dropdown-menu dropdown-menu-right dropdown-menu-sm"
                style="top: 40px;display:block;"
                [hidden]="config.showSuperAppMenu == undefined || !config.showSuperAppMenu">
                <div class="dropdown-header">
                    <strong>Select Application</strong>
                </div>
                <dhs-domain-platform [domainPlatformList]="appService._currentSessionData.superApps">
                </dhs-domain-platform>
            </div>
        </div> -->
    </div>
    <!--web logo-->
    <div class="_wf-lp-login-form-container">
        <!-- <div class="text-block-377 _wf-lp-textbox-formobile" *ngIf="headerInfo.default_tagline_needed"><span
                [innerHtml]="headerInfo.login_tag"></span></div> -->
        <div class="_wf-lp-blockll-for-shadow"></div>
        <img [src]="headerInfo.banner" alt="" class="image-36"
            onerror="this.onerror=null;this.src='/assets/images/login-BG.png';">
        <!-- <div class="display_msg">{{headerInfo.name}} Healthcloud</div> -->
        <div class="_wf-lp-image-container">
            <!-- <div class="text-block-377" *ngIf="headerInfo.default_tagline_needed"><span
                    [innerHtml]="headerInfo.login_tag">
                </span>
            </div> -->
            <img [src]="headerInfo.banner" loading="lazy"
                sizes="(max-width: 479px) 100vw, (max-width: 1919px) 57vw, 61vw" alt="" class="image-37"
                onerror="this.onerror=null;this.src='/assets/images/login-BG.png';">
        </div>
        <div class="_wf-lp-whitebg">
            <div class="_wf-lp-login-form" style="display: block;">
                <div class="login-overlay hide-after-1024px">
                </div>

                <div class="_wf-lp-form-block">
                    <div class="close-btn-form" *ngIf="utilService.isMobile()" (click)="navigateToLogin()">
                        <i class="fa fa-times-circle"></i>
                    </div>
                    <div class="mb-4">
                        <!-- <div class="forgot-password-top-section">
                            <a class="d-inline-flex" href="javascript:void(0)" (click)="backToReset()" *ngIf="show">
                                <img src="assets/images/grid-back.png" />
                            </a>
                        </div> -->
                        <div class="pass-screen form-top-section">
                            <!--for navigate back to login screen-->
                            <div class="landing-form-back-button-container" *ngIf="!show && !showOtpComponent">
                                <a class="" href="javascript:void(0)" (click)="navigateToLogin()">
                                    <img src="assets/images/grid-back.png">
                                </a>
                            </div>
                            <!--for navigate back to forgot password screen-->
                            <div class="landing-form-back-button-container">
                                <a class="back-not-allowed" href="javascript:void(0)"
                                    *ngIf="showOtpComponent && showTimer">
                                    <img src="assets/images/grid-back.png" />
                                </a>
                                <a class="" href="javascript:void(0)" (click)="backToForgotPass()"
                                    *ngIf="showOtpComponent && !showTimer">
                                    <img src="assets/images/grid-back.png" />
                                </a>
                            </div>
                            <!--for navigate back to otp screen-->
                            <div class="landing-form-back-button-container">
                                <a class="" href="javascript:void(0)" (click)="backToReset()" *ngIf="show">
                                    <img src="assets/images/grid-back.png" />
                                </a>
                            </div>
                            <div class="landing-form-heading">
                                {{'field.label.online_payment' | translate | async }}
                            </div>
                        </div>

                        <form class="mt-4 forgotPasswordForm" [formGroup]="forgotPasswordForm">
                            <!-- <div class="row"> -->

                            <div *ngIf="!show && !showOtpComponent">
                                <div class="floating-input-group c-mb-3">
                                    <ng-template #errorTemplate>
                                        <div>
                                            <div *ngIf="lf.user_name.errors.required">
                                                {{'required.name' | translate | async }}
                                            </div>
                                        </div>
                                    </ng-template>
                                    <input type="text" formControlName="user_name" placeholder=""
                                        [ngClass]="{ 'is-invalid': submitted && lf.user_name.errors }" required
                                        class="form-control floating-input" />
                                    <label for="user_name" class="floating-placeholder">{{'field.label.guest_name' |
                                        translate | async
                                        }}</label>
                                    <div *ngIf="submitted && lf.user_name.errors" class="input-detail-error form-v2"
                                        [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="floating-input-group c-mb-3">
                                    <ng-template #errorTemplate>
                                        <div>
                                            <div *ngIf="lf.mob.errors.required">
                                                {{'required.telecom' | translate | async }}
                                            </div>
                                            <div *ngIf="lf.mob.errors.pattern">
                                                {{'field.label.alphabet_cannot_be_accepted' | translate | async }} Or
                                                {{'field.label.mobile_number_digits' | translate | async }}
                                            </div>
                                        </div>
                                    </ng-template>
                                    <input type="text" formControlName="mob" placeholder=""
                                        [ngClass]="{ 'is-invalid': submitted && lf.mob.errors }" required
                                        class="form-control floating-input"
                                        pattern="{{headerInfo.mobile_no_regex?headerInfo.mobile_no_regex:'^[0-9+]{10,12}$'}}" />
                                    <label for="mob" class="floating-placeholder">{{'field.label.guest_mobile_number' |
                                        translate | async
                                        }}</label>
                                    <div *ngIf="submitted && lf.mob.errors" class="input-detail-error form-v2"
                                        [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="floating-input-group c-mb-3">
                                    <input type="text" formControlName="email" placeholder=""
                                        class="form-control floating-input" />
                                    <label for="email" class="floating-placeholder">{{'field.label.email_address' |
                                        translate | async
                                        }}</label>
                                </div>
                                <div class="floating-input-group c-mb-3" *ngIf="isKarexpert=='karexpert'">
                                    <ng-template #errorTemplate>
                                        <div>
                                            <div *ngIf="lf.account_id.errors.required">
                                                {{'required.account_id' | translate | async }}
                                            </div>
                                            <div *ngIf="lf.account_id.errors.minlength">
                                                {{'field.label.account_Url_required' | translate | async }}</div>
                                            <div *ngIf="lf.account_id.errors.pattern">
                                                {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async }}
                                            </div>
                                        </div>
                                    </ng-template>
                                    <input type="text" formControlName="account_id" placeholder=""
                                        [ngClass]="{ 'is-invalid': submitted && lf.account_id.errors }" minlength="2"
                                        maxlength="255" pattern="^[a-zA-Z0-9&._@]+" required
                                        class="form-control floating-input" />
                                    <label for="account_url" class="floating-placeholder">{{'field.label.account_url' |
                                        translate | async
                                        }}</label>
                                    <div *ngIf="submitted && lf.account_id.errors" class="input-detail-error form-v2"
                                        [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="col-12 p-0 mt-42">
                                    <button class="login-button btn-gradient button-hover text-white"
                                        (click)="generateOTP()">{{'button.generate_otp' | translate | async }}
                                        <i class="fa fa-angle-right lg-btn-icon" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </form>

                        <div class="mt-2" *ngIf="showOtpComponent">
                            <!-- <p>We have sent you 6 digit verification code on your mobile to verify contact details.</p> -->
                            <p>{{'field.label.Enter_OTP' | translate | async }}</p>
                        </div>

                        <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent"
                            [config]="config" [resetOTP]="ResetsetOpt">
                        </app-otp-input>

                        <div class="col-12 p-0 mt-4" *ngIf="showOtpComponent">
                            <button class="login-button btn-gradient button-hover text-white" (click)="verifyOtp()"
                                #changeOtpBtn disabled>
                                {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                                    aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="col-12 mt-1 p-0" *ngIf="showOtpComponent">
                            <span *ngIf="!showTimer" class="cLink" (click)="generateOTP()" (click)="clear()">
                                {{'field.label.resend_OTP' | translate | async }}</span>
                            <span class="timer" style="cursor: not-allowed; color: gray;" *ngIf="showTimer">
                                {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}}
                                {{'field.label.seconds' | translate | async}}
                            </span>
                        </div>
                    </div>
                    <div class="_wf-lp-signup-container">
                        <div class="_wf-lp-logo-footer-main _wf-lp-mobile-footer">
                            <div class="_wf-lp-img-block">
                                <div class="_wf-lp-footer-logo"><img src="assets/images/logo-powered-white.svg"
                                        loading="lazy" alt=""></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="_wf-lp-logo-footer-main">
                <div class="_wf-lp-footer-logo"><img src="assets/images/logo-powered-white.svg" loading="lazy"></div>
            </div>
        </div>
    </div>

</div>
<div *ngIf="loggedIn" class="main-content-container mt-4">
    <div class="d-flex">
        <div *ngIf="searchPatientDataSource" class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <label>Search Patient</label>
            <input-search [placeholder]="'Search'" [clearSearchResult]="true" [data]="searchPatientDataSource"
                (patientResult)="searchResult($event)"></input-search>
        </div>
        <div class="session-timeout"> Session Timeout in : <strong>{{ minutes }}:{{ seconds }}</strong>
        </div>
    </div>
    <div *ngIf="patientData && patientData.length>0" class="col-12 p-0 table-last-elements">
        <data-table [fields]="patientFields" [view_care_type]="false" [data]="patientData"
            (editValue)="editValue($event)">
        </data-table>
        <div class="col-12 text-center mt-2" id="showButtons">
            <button class="aside-fixed-button primary-btn submitButton" (click)="onMakePayment()">Make Payment<i
                    class="fa fa-check ml-2" aria-hidden="true"></i></button>
        </div>
    </div>
</div>
<div dhs-modal></div>